import React, { useEffect, useState } from "react";
import { Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchContestDetails } from "store/actions/sportContestAction";
import ReuseableTable from "components/Tables/ReuseableTable";

const column = [
  "Institute Name",
  "Institute Level",
  "County",
  "State",
  "Email",
];

const keyMaps = {
  "Institute Name": "instituteName",
  "Institute Level": "instituteLevel",
  County: "county",
  State: "state",
  Email: "email",
};

const ContestSchools = ({ contestId }) => {
  const dispatch = useDispatch();
  const { contestDetails } = useSelector((state) => state.contest);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_schools",
        contestId,
        lastVisible: contestDetails?.lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchContestDetails({ collectionName: "contest_schools", contestId })
    ).finally(() => setIsFetching(false));
  }, []);

  return (
    <div className="p-0">
      {isFetching ? (
        <div className="text-center py-4 text-primary">
          <Spinner animation="border" size="md" />
        </div>
      ) : (
        <>
          <ReuseableTable
            columns={column}
            keyMap={keyMaps}
            data={contestDetails?.data}
          />
          {contestDetails?.hasMore && (
            <div className="text-center py-2">
              <Button
                color="primary"
                onClick={handleLoadMore}
                disabled={isFetching || isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContestSchools;
